import React from 'react';
import { useTranslation } from 'react-i18next';
import './MinDisplayTimeInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const MinDisplayTimeInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  options.push({ text: `1 second`, value: '1' });

  for (let i = 1.5; i <= 10; i += 0.5) {
    options.push({ text: `${i} seconds`, value: i.toString() });
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          aggregatorMinDisplayTime: parseFloat(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          aggregatorMinDisplayTime: parseFloat(option.value),
        });
      }
    }
  };

  return (
    <div className="min-display-time-input">
      <div className="input-title">
        {t('producer.inputs.min-display-time.title')}
        <Help
          title="Minimum Display Time"
          text="Minimum Display Time sets the shortest duration that a closed caption block will remain visible on screen.<br/><br/>- Increasing this value ensures captions stay on screen long enough for viewers to read them.<br/>- Decreasing this value allows captions to change more quickly, which may be useful for fast-paced content but can make them harder to read.<br/><br/>Adjust this setting to balance readability with the timing of your content."
        />
      </div>
      <Dropdown
        value={project.encoder.aggregatorMinDisplayTime.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.min-display-time.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.min-display-time.footer')}</div>
    </div>
  );
};

export default React.memo(MinDisplayTimeInput);
